import React, { useState } from 'react';
import './CalcAProofUploadForm.css';
// import './CommonButton.css';
import './CommonProgress.css';
import { useUserContext } from '../../contexts/UserContext';

import { BackendService } from '../../backend/BackendService';
import { CalcAProofResult, CalcAProofResultDefaultData } from '../parts/CalcAProofData';

import logo from '../../images/a-proof.png';
import { CommonDropArea } from './CommonDropArea';

type Props = {
    setCalcResult: (calcResult: CalcAProofResult) => void
}

export const CalcAProofUploadForm: React.FC<Props> = ({setCalcResult}) => {
    const userContext = useUserContext();

    const [message, setMessage] = useState<string>();
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);

    const dropProp = {
        callbacks: {
            onSetFile: (files: FileList) => {
                const file: File = files[0];
                setCalcResult(CalcAProofResultDefaultData);
                if (1 < files.length) {
                    setMessage('');
                    setError('Multiple files cannot be calculated.');
                    return;
                }
                // 1年分のデータファイル：1.03MB × 1.5 ≒ 1.6MB ≒ 1638KB = 1677312B
                if (1677312 < file.size) {
                    console.log('File is too large. size=' + file.size);
                    setMessage('');
                    setError('"' + file.name + '" is too large. size=' + file.size + ' bytes');
                    return;
                }
                setMessage('Uploading... ' + file.name);
                setError('');
                setLoading(true);
                console.log('Uploading...');
                BackendService.postCalcap(userContext.idToken, file)
                    .then(response => {
                        console.log("BackendService.postCalcap :then");
                        console.log(response);
                        if ("0" === response.status) {
                            setCalcResult(response);
                            setMessage('Uploaded... ' + file.name);
                        } else {
                            setCalcResult(CalcAProofResultDefaultData);
                            setError(response.message);
                        }
                        setLoading(false);
                        console.log('setCalcResult() done...');
                    })
                    .catch(error => {
                        console.log("BackendService.postCalcap :catch");
                        console.log(error);
                        setLoading(false);
                        userContext.logout();
                        window.location.href = '/';
                    });
            },
            onFailure: (err: string) => {
                console.log('error: ' + err);
                setError(err);
            }
        },
        loading: loading,
        // message: message,
    }

    return (
        <div className="CalcAProofUploadForm_content">
            <div className="CalcAProofUploadForm_header">
                {/* 商標を伏せるためイメージ非表示・説明文変更 */}
                {/* <img className="CalcAProofUploadForm_image" src={logo} width={68} height={54} /> */}
                {/* <div className="CalcAProofUploadForm_discription">
                    Welcome to "A-Proof<span className="CalcAProofUploadForm_super">TM</span>”
                    &nbsp;(<span className="CalcAProofUploadForm_name_red">A</span>sahi&nbsp;
                    <span className="CalcAProofUploadForm_name_red">K</span>asei&nbsp;
                    <span className="CalcAProofUploadForm_name_red">PR</span>ograms for
                    <span className="CalcAProofUploadForm_name_red">O</span>ptimized
                    <span className="CalcAProofUploadForm_name_red">O</span>peration
                    <span className="CalcAProofUploadForm_name_red">F</span>actory).<br/>
                    These calculated values are just for reference purpose.
                </div> */}
                <div className="CalcAProofUploadForm_discription">
                    Welcome to "Current Optimization Service”.&nbsp;These calculated values are just for reference purpose.
                </div>
            </div>
            <br />
            <CommonDropArea prop={dropProp} />
            <div>{message}</div>
            <div className="error">{error}</div>
        </div>
    );
};
